//inspired by https://github.com/mathieumg/i18next-callback-backend/tree/initial_version
class CustomCallbackBackend {
    // @ts-ignore
    constructor(...args) {
        // @ts-ignore
        this.init(...args);
    }
    // @ts-ignore
    create(...args) {
        // @ts-ignore
        this.options.customCreate(...args);
    }
    // @ts-ignore
    missingCustomCallback(callbackType) {
        // @ts-ignore
        return (language, namespace, callback) => callback(new Error(`You must provide a "custom${callbackType}" option with the ` +
            `"CustomCallbackBackend".`));
    }
    // @ts-ignore
    init(services, options = {}, i18nextOptions = {}) {
        // @ts-ignore
        this.options = Object.assign(Object.assign({ customCreate: () => { }, customLoad: this.missingCustomCallback("Load"), customLoadMulti: this.missingCustomCallback("LoadMulti") }, i18nextOptions), options);
    }
    // @ts-ignore
    read(...args) {
        // @ts-ignore
        this.options.customLoad(...args);
    }
    // @ts-ignore
    readMulti(...args) {
        // @ts-ignore
        this.options.customLoadMulti(...args);
    }
}
Object.defineProperty(CustomCallbackBackend, "type", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: "backend"
});
export default CustomCallbackBackend;
//# sourceMappingURL=i18next-callback-backend.js.map